import { Injectable } from '@angular/core';
import { UrlFactory } from './url-factory';

@Injectable({ providedIn: 'root' })
export class LaunchDarklyGateway {
  constructor(private _urlFactory: UrlFactory) {}

  /**
   * TODO: Retrieve LD feature flags and load
   * them into the FeatureFacade similar to feature flags currently.
   */

  featureFlagsSecure(featureFlag: string, env: string) {
    return this._urlFactory.createUrl(
      'launchDarkly',
      `web/${env}/ff/${featureFlag}/user`,
    );
  }

  featureFlagsPublic(featureFlag: string, env: string) {
    return this._urlFactory.createUrl(
      'launchDarkly',
      `web/${env}/ff/${featureFlag}`,
    );
  }
}
